// City-level geocoding for HYROX gym locations
// Approximate lat/lng for distance calculations (~5-10mi accuracy)

export const CITY_COORDS = {
  'Albuquerque, NM': [35.0844, -106.6504],
  'Alexandria, VA': [38.8048, -77.0469],
  'Allen, TX': [33.1032, -96.6706],
  'Ann Arbor, MI': [42.2808, -83.7430],
  'Arlington, VA': [38.8799, -77.1068],
  'Arvada, CO': [39.8028, -105.0875],
  'Astoria, NY': [40.7720, -73.9233],
  'Atlanta, GA': [33.7490, -84.3880],
  'Austin, TX': [30.2672, -97.7431],
  'Baltimore, MD': [39.2904, -76.6122],
  'Bellevue, WA': [47.6101, -122.2015],
  'Bethesda, MD': [38.9847, -77.0947],
  'Birmingham, AL': [33.5186, -86.8104],
  'Boise, ID': [43.6150, -116.2023],
  'Boston, MA': [42.3601, -71.0589],
  'Boulder, CO': [40.0150, -105.2705],
  'Brooklyn, NY': [40.6782, -73.9442],
  'Buffalo, NY': [42.8864, -78.8784],
  'Cambridge, MA': [42.3736, -71.1097],
  'Centennial, CO': [39.5791, -104.8769],
  'Charleston, SC': [32.7765, -79.9311],
  'Charlotte, NC': [35.2271, -80.8431],
  'Cherry Hill, NJ': [39.9348, -75.0307],
  'Chicago, IL': [41.8781, -87.6298],
  'Cincinnati, OH': [39.1031, -84.5120],
  'Cleveland, OH': [41.4993, -81.6944],
  'Colorado Springs, CO': [38.8339, -104.8214],
  'Columbus, OH': [39.9612, -82.9988],
  'Coral Gables, FL': [25.7215, -80.2684],
  'Dallas, TX': [32.7767, -96.7970],
  'Delray Beach, FL': [26.4615, -80.0728],
  'Denver, CO': [39.7392, -104.9903],
  'Des Moines, IA': [41.5868, -93.6250],
  'Durham, NC': [35.9940, -78.8986],
  'El Paso, TX': [31.7619, -106.4850],
  'Eugene, OR': [44.0521, -123.0868],
  'Fort Lauderdale, FL': [26.1224, -80.1373],
  'Fort Worth, TX': [32.7555, -97.3308],
  'Frisco, TX': [33.1507, -96.8236],
  'Garden City, NY': [40.7268, -73.6343],
  'Grand Rapids, MI': [42.9634, -85.6681],
  'Greenville, SC': [34.8526, -82.3940],
  'Greenwich, CT': [41.0262, -73.6282],
  'Hartford, CT': [41.7658, -72.6734],
  'Henderson, NV': [36.0395, -114.9817],
  'Hoboken, NJ': [40.7440, -74.0324],
  'Honolulu, HI': [21.3069, -157.8583],
  'Houston, TX': [29.7604, -95.3698],
  'Indianapolis, IN': [39.7684, -86.1581],
  'Irvine, CA': [33.6846, -117.8265],
  'Jackson, MS': [32.2988, -90.1848],
  'Jacksonville, FL': [30.3322, -81.6557],
  'Jersey City, NJ': [40.7178, -74.0431],
  'Kansas City, MO': [39.0997, -94.5786],
  'King of Prussia, PA': [40.0893, -75.3963],
  'Knoxville, TN': [35.9606, -83.9207],
  'La Jolla, CA': [32.8328, -117.2713],
  'Las Vegas, NV': [36.1699, -115.1398],
  'Little Elm, TX': [33.1626, -96.9375],
  'Long Beach, CA': [33.7701, -118.1937],
  'Long Island City, NY': [40.7447, -73.9485],
  'Los Angeles, CA': [34.0522, -118.2437],
  'Louisville, KY': [38.2527, -85.7585],
  'Lubbock, TX': [33.5779, -101.8552],
  'Madison, WI': [43.0731, -89.4012],
  'Manchester, NH': [42.9956, -71.4548],
  'Memphis, TN': [35.1495, -90.0490],
  'Mesa, AZ': [33.4152, -111.8315],
  'Miami Beach, FL': [25.7907, -80.1300],
  'Miami, FL': [25.7617, -80.1918],
  'Milwaukee, WI': [43.0389, -87.9065],
  'Minneapolis, MN': [44.9778, -93.2650],
  'Missoula, MT': [46.8721, -113.9940],
  'Montclair, NJ': [40.8259, -74.2090],
  'Morristown, NJ': [40.7968, -74.4815],
  'Naperville, IL': [41.7508, -88.1535],
  'Naples, FL': [26.1420, -81.7948],
  'Nashville, TN': [36.1627, -86.7816],
  'New Haven, CT': [41.3083, -72.9279],
  'New Orleans, LA': [29.9511, -90.0715],
  'New York, NY': [40.7128, -74.0060],
  'Newton, MA': [42.3370, -71.2092],
  'Oklahoma City, OK': [35.4676, -97.5164],
  'Omaha, NE': [41.2565, -95.9345],
  'Orlando, FL': [28.5383, -81.3792],
  'Overland Park, KS': [38.9822, -94.6708],
  'Palo Alto, CA': [37.4419, -122.1430],
  'Park Ridge, IL': [42.0111, -87.8406],
  'Pasadena, CA': [34.1478, -118.1445],
  'Philadelphia, PA': [39.9526, -75.1652],
  'Phoenix, AZ': [33.4484, -112.0740],
  'Pittsburgh, PA': [40.4406, -79.9959],
  'Plano, TX': [33.0198, -96.6989],
  'Portland, ME': [43.6591, -70.2568],
  'Portland, OR': [45.5152, -122.6784],
  'Princeton, NJ': [40.3573, -74.6672],
  'Providence, RI': [41.8240, -71.4128],
  'Provo, UT': [40.2338, -111.6585],
  'Raleigh, NC': [35.7796, -78.6382],
  'Richardson, TX': [32.9483, -96.7299],
  'Richmond, VA': [37.5407, -77.4360],
  'Rochester, NY': [43.1566, -77.6088],
  'Royal Oak, MI': [42.4895, -83.1446],
  'Sacramento, CA': [38.5816, -121.4944],
  'Salt Lake City, UT': [40.7608, -111.8910],
  'San Antonio, TX': [29.4241, -98.4936],
  'San Diego, CA': [32.7157, -117.1611],
  'San Francisco, CA': [37.7749, -122.4194],
  'Santa Monica, CA': [34.0195, -118.4912],
  'Sarasota, FL': [27.3364, -82.5307],
  'Savannah, GA': [32.0809, -81.0912],
  'Scarsdale, NY': [40.9887, -73.7846],
  'Scottsdale, AZ': [33.4942, -111.9261],
  'Seattle, WA': [47.6062, -122.3321],
  'Smyrna, GA': [33.8839, -84.5143],
  'St. Louis, MO': [38.6270, -90.1994],
  'St. Paul, MN': [44.9537, -93.0900],
  'St. Petersburg, FL': [27.7676, -82.6403],
  'Stamford, CT': [41.0534, -73.5387],
  'Syracuse, NY': [43.0481, -76.1474],
  'Tacoma, WA': [47.2529, -122.4443],
  'Tampa, FL': [27.9506, -82.4572],
  'Tempe, AZ': [33.4255, -111.9400],
  'The Woodlands, TX': [30.1658, -95.4613],
  'Tucson, AZ': [32.2226, -110.9747],
  'Tulsa, OK': [36.1540, -95.9928],
  'Virginia Beach, VA': [36.8529, -75.9780],
  'Washington, DC': [38.9072, -77.0369],
  'West Hollywood, CA': [34.0900, -118.3617],
  'White Plains, NY': [41.0340, -73.7629],
  'Wilmington, DE': [39.7391, -75.5398],
  'Wilmington, NC': [34.2257, -77.9447],
  'Worcester, MA': [42.2626, -71.8023],
};

// Haversine formula — returns distance in miles
export function getDistanceMiles(lat1, lon1, lat2, lon2) {
  const R = 3958.8; // Earth radius in miles
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}
